module.exports = __webpack_public_path__ + "static/img/hb_57-min.d0b754f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/hb_57-min.png
// module id = 3Bip
// module chunks = 1